import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { DetailField } from '../details/DetailField';
import { spotifyHeaderMessages as messages } from './spotifyHeaderMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Spotify header; each part uses its own slice of it */
import styles from './SpotifyHeader.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface HeaderPositionFieldsProps {
  focusX: number;
  focusY: number;
  /** Left / right shows only when the picture is wider than the header after the cover fit. */
  showLeftRight: boolean;
  onChange: (focus: { focusX?: number; focusY?: number }) => void;
  /** The hint of the field. Default: the hint of the header ("… the green box. Spotify puts your name bottom left."). */
  hint?: string;
}

/** "Position" of step 3 (design spotify-header a2, a3): the point of the picture that goes to the green box. */
const HeaderPositionFieldsComponent: React.FC<HeaderPositionFieldsProps> = ({
  focusX,
  focusY,
  showLeftRight,
  onChange,
  hint,
}) => {
  const intl = useIntl();
  const row = (label: string, value: number, testId: string, change: (next: number) => void) => (
    <div className={styles.slider}>
      <label className={styles.sliderLabel} htmlFor={testId}>
        {label}
      </label>
      <input
        id={testId}
        type="range"
        min={0}
        max={100}
        step={1}
        value={Math.round(value * 100)}
        className={styles.range}
        data-testid={testId}
        onChange={(event) => change(Number(event.currentTarget.value) / 100)}
      />
    </div>
  );
  return (
    <DetailField
      title={intl.formatMessage(messages.positionTitle)}
      hint={hint ?? intl.formatMessage(messages.positionHint)}
    >
      {row(intl.formatMessage(messages.upDown), focusY, 'header-focus-y', (next) => onChange({ focusY: next }))}
      {showLeftRight &&
        row(intl.formatMessage(messages.leftRight), focusX, 'header-focus-x', (next) => onChange({ focusX: next }))}
    </DetailField>
  );
};

export const HeaderPositionFields = TypedMemo(HeaderPositionFieldsComponent);
